module.exports = __webpack_public_path__ + "media/app/images/check-icon-0ddd657a6fdff236a70b3f086a09a71d.png";